import { AfterViewInit, Component, OnDestroy, OnInit, inject } from '@angular/core';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import {
  FontsLoaderComponent,
  LearnizActions,
  LearnizState,
  PluginService,
  ScormService,
  ToggleReadSpeakerVisibilityComponent,
  WordingPipe,
} from '@jump-tools-front/shared';
import { Store } from '@ngxs/store';
import { ChapterLayoutComponent } from '../../features/chapter/chapter-layout.component';
import { LandingPageComponent } from '../../features/landing-page/landing-page.component';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PLUGINS } from '@jump-tools-front/shared-interfaces';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'learniz-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  imports: [FontsLoaderComponent, RouterOutlet, ToggleReadSpeakerVisibilityComponent, AsyncPipe, WordingPipe],
})
export class LayoutComponent implements OnInit, AfterViewInit, OnDestroy {
  private _store = inject(Store);
  private _route = inject(ActivatedRoute);
  private _pluginService = inject(PluginService);
  private _scormService = inject(ScormService);
  isPreview = this._store.selectSnapshot(LearnizState.isPreview);
  backofficeUrl$ = this._store.select(LearnizState.getBackofficeUrl);
  isLandingPage = false;
  learnizParams = this._store.selectSnapshot(LearnizState.getLearnizParams);
  private _destroy$ = new Subject<void>();

  ngOnInit(): void {
    const backofficeUrl = this._route.snapshot.queryParams.returnBackoffice;

    if (!!backofficeUrl) {
      this._store.dispatch(new LearnizActions.SaveBackofficeUrl(backofficeUrl));
    }
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  ngAfterViewInit(): void {
    if (!this._scormService.isScormActive) {
      this._pluginService
        .getAllPlatform$()
        .pipe(takeUntil(this._destroy$))
        .subscribe(val => {
          if (val.some(v => v.type === PLUGINS.READ_SPEAKER)) {
            this._pluginService.launchReadSpeaker();
          }
          if (val.some(v => v.type === PLUGINS.STELLIA)) {
            const courseKey = this._store.selectSnapshot(LearnizState.getSlug);
            if (!courseKey) {
              return;
            }
            this._pluginService.launchStellia(courseKey);
          }
        });
    }
  }

  getBackofficeUrl(url: string): string {
    const slug = this._store.selectSnapshot(LearnizState.getSlug);
    if (this.isLandingPage) {
      return `${url}editor/learniz-editor/${slug}/learniz-general-params`;
    }
    const chapter = this._store.selectSnapshot(LearnizState.getCurrentChapter);
    const learniz = this._store.selectSnapshot(LearnizState.getLearniz);
    const chapterIndex = learniz.chapters.findIndex(c => c.slug === chapter.slug);
    const slide = this._store.selectSnapshot(LearnizState.getCurrentSlide);
    const slideIndex = chapter.slides.findIndex(s => s.slug === slide.slug);
    return `${url}editor/learniz-editor/${slug}/learniz-content-editor/chapter/${chapterIndex}/${slideIndex}`;
  }

  loadComponent(component: LandingPageComponent | ChapterLayoutComponent): void {
    this.isLandingPage = component instanceof LandingPageComponent;
  }

  goBackCreations(url: string): string {
    return `${url}admin/trainings`;
  }
}
